import React, { useState, useEffect } from "react";
import axios from "../../../../utils/axios";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  Chip,
} from "@mui/material";
import Loading from "../../../utilities/Loading";

const Payment = () => {
  const [expiredDevices, setExpiredDevices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Calculate total due amount
  const totalDueAmount = expiredDevices.reduce((total, device) => {
    const cost = device.subscription_cost
      ? parseFloat(device.subscription_cost)
      : 0;
    return total + cost;
  }, 0);

  useEffect(() => {
    const fetchDevices = async () => {
      try {
        setIsLoading(true);
        const response = await axios.post("view/devices");
        const currentDate = new Date();

        // Filter for expired devices
        const expired = response?.data?.filter(
          (item) => new Date(item.subscription_end) <= currentDate
        );

        setExpiredDevices(expired || []);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching devices:", error);
        setIsLoading(false);
      }
    };

    fetchDevices();
  }, []);

  return (
    <div className="payment-screen">
      {/* <Loading isLoading={isLoading} /> */}

      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" sx={{ color: "#1C5E85", mb: 1 }}>
          Subscription Renewals
        </Typography>
        <Typography variant="body1" sx={{ color: "#666" }}>
          Renew your expired device subscriptions to continue receiving data
        </Typography>
      </Box>

      {expiredDevices.length === 0 && !isLoading ? (
        <Paper elevation={2} sx={{ p: 4, textAlign: "center" }}>
          <Typography variant="h6" sx={{ color: "#1C5E85" }}>
            All your devices have active subscriptions!
          </Typography>
          <Typography variant="body1" sx={{ mt: 1 }}>
            There are no devices that need renewal at this time.
          </Typography>
        </Paper>
      ) : (
        <>
          <TableContainer component={Paper} elevation={3}>
            <Table sx={{ minWidth: 650 }}>
              <TableHead sx={{ backgroundColor: "#09c4ff" }}>
                <TableRow>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                    Device Name
                  </TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                    Device Type
                  </TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                    Subscription End
                  </TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                    Subscription Cost
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {expiredDevices.map((device, index) => (
                  <TableRow
                    key={index}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {device.alias_name}
                    </TableCell>
                    <TableCell>
                      {device.device_type === "flow"
                        ? "Flow Device"
                        : "Level Device"}
                    </TableCell>
                    <TableCell>
                      {new Date(device.subscription_end).toLocaleDateString(
                        "en-US",
                        {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        }
                      )}
                    </TableCell>
                    <TableCell>
                      {device.subscription_cost
                        ? `₹${device.subscription_cost}`
                        : "Contact Support"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Payment Information */}
          <Paper elevation={3} sx={{ mt: 4, p: 3 }}>
            <Box sx={{ mb: 3 }}>
              <Typography variant="h5" sx={{ color: "#1C5E85", mb: 2 }}>
                Payment Information
              </Typography>
              <Typography
                variant="h6"
                sx={{ color: "#09c4ff", fontWeight: "bold" }}
              >
                Total Due Amount: ₹{totalDueAmount.toFixed(2)}
              </Typography>
            </Box>

            <Box
              sx={{
                backgroundColor: "#f5f5f5",
                p: 2,
                borderRadius: 1,
                border: "1px solid #e0e0e0",
                mb: 2,
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", mb: 1 }}
              >
                Bank Details for Payment:
              </Typography>
              <Typography variant="body1">
                <strong>Account name:</strong> VNC ROBOTICS
              </Typography>
              <Typography variant="body1">
                <strong>Account Number:</strong> 136805502689
              </Typography>
              <Typography variant="body1">
                <strong>IFSC Code:</strong> ICIC0001368
              </Typography>
            </Box>

            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              After making the payment, please contact us at{" "}
              <strong>+91 84011 09791</strong> or{" "}
              <strong>vinay@vncrobotics.com</strong> to activate your device.
            </Typography>
          </Paper>
        </>
      )}
    </div>
  );
};

export default Payment;
